import { useState } from "react";
import { Modal, Dropdown } from "semantic-ui-react";

import { ModalContactTable } from "components/modals/modal_contact_table/ModalContactTable";
import PageContainer from "components/PageContainer";

const IncludeContactsModal = ({ entityId, campaignId, onSuccess }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Modal
      size="large"
      trigger={<Dropdown.Item>Include Contacts</Dropdown.Item>}
      closeIcon
      open={modalOpen}
      onOpen={handleOpen}
      onClose={handleClose}
      closeOnDimmerClick={false}
    >
      <Modal.Header>Include Contacts</Modal.Header>
      <Modal.Content>
        <PageContainer styles={{ height: "80vh", padding: 0 }}>
          <ModalContactTable
            entityId={entityId}
            campaignId={campaignId}
            onSuccess={onSuccess}
            enableSearch
          />
        </PageContainer>
      </Modal.Content>
    </Modal>
  );
};

export { IncludeContactsModal };
